// 만 나이(International age) 계산 함수
export function calculateInternationalAge(birthDateString: string | null): number | null {
  // birthDateString이 'YYYY.MM.DD' (혹은 'YYYY-MM-DD' 등) 형태라고 가정
  if (!birthDateString) return null;
  const cleanBirth = birthDateString.replace(/\./g, "-").replace(/\//g, "-");
  const parts = cleanBirth.split("-");
  if (parts.length < 3) return null;
  const birthYear = parseInt(parts[0], 10);
  const birthMonth = parseInt(parts[1], 10) - 1;
  const birthDay = parseInt(parts[2], 10);
  if (isNaN(birthYear) || isNaN(birthMonth) || isNaN(birthDay)) return null;
  const birthDate = new Date(birthYear, birthMonth, birthDay);

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthday =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  if (!hasHadBirthday) age -= 1;
  return age;
}
